import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { backOption, hiddenItem, noNav } from '../../navigators/NavigatorOptions'
import { CommSetupScreens } from '../CommSetup/CommunicatorSetupStack'
import { IndicatorLightsWithBackButton } from '../IndicatorLights/IndicatorLightsStack'
import FAQItemPage from './FAQItemPage'
import FAQMonitoringSystemPage from './FAQMonitoringSystemPage'
import FAQHomePage from './FAQHomePage'
import FAQDeviceSystemPage from './FAQDeviceSystemPage'
import FAQBSCPage from './FAQBSCPage'

const Stack = createStackNavigator()

export default function Screen() {
  return (
    <Stack.Navigator initialRouteName="FAQHomePage">
      <Stack.Screen name="FAQHomePage" component={FAQHomePage} options={noNav('common:faqTitle', 'small')} />
      <Stack.Screen name="CommunicatorSetupStack" component={CommSetupScreens} options={hiddenItem(true)} />
      <Stack.Screen name="FAQItemPage" component={FAQItemPage} options={backOption('FAQItemPage')} />
      <Stack.Screen name="IndicatorLightsStack" component={IndicatorLightsWithBackButton} options={hiddenItem(true)} />
      <Stack.Screen name="FAQMonitoringSystemPage" component={FAQMonitoringSystemPage} options={backOption('FAQMonitoringSystemPage')} />
      <Stack.Screen name="FAQDeviceSystemPage" component={FAQDeviceSystemPage} options={backOption('FAQDeviceSystemPage')} />
      <Stack.Screen name="FAQBSCPage" component={FAQBSCPage} options={backOption('FAQBSCPage')} />
    </Stack.Navigator>
  )
}
